import React, { useContext, useEffect, useState } from "react";
import {
  Heading,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { MyContext } from "../../MyProvider";

import AdminLogin from "../AdminNav/Login";

import { PageHeader, SectionTitle } from "../../components/ui";

function Birthday() {
  const {userData,horoData}=useContext(MyContext);

  const [todayBirthdays, setTodayBirthdays] = useState([]);
  const [upcomingBirthdays, setUpcomingBirthdays] = useState([]);
  const [alreadyBirthdays, setAlreadyBirthdays] = useState([]);

  const todayBirthdaysList = [];
  const upcomingBirthdaysList = [];
  const alreadyBirthdayList = [];

  
  useEffect(()=>{
    const today = new Date();
  

  
    userData.forEach((person) => {
      const dob = person.DOB; // Assuming "DOB" is the date of birth property
      const fullName = person.fname + " " + person.lname;
      const contact = person.phone;
  
      // Check for null DOB or empty string
      if (!dob) {
        return;
      }
  
      // Parse DOB in "dd/mm/yyyy" format
      const dobParts = dob.split("/");
      if (dobParts.length !== 3) {
        return;
      }
      const curdate = parseInt(dobParts[0], 10);
      const curmonth = parseInt(dobParts[1], 10) - 1;
  
      if (curdate === today.getDate() && curmonth === today.getMonth()) {
        todayBirthdaysList.push({
          fullName,
          dob,
          contact,
          curdate,
          curmonth,
        });
      } else if (
        curmonth < today.getMonth() ||
        (curmonth === today.getMonth() && curdate < today.getDate())
      ) {
        alreadyBirthdayList.push({
          fullName,
          dob,
          contact,
          curdate,
          curmonth,
        });
      } else {
        upcomingBirthdaysList.push({
          fullName,
          dob,
          contact,
          curdate,
          curmonth,
        });
      }
    });
  
    horoData.forEach((person) => {
      const dob = person.DOB; // Assuming "DOB" is the date of birth property
      const fullName = person.fname + " " + person.lname;
      const contact = person.phone;
  
      // Check for null DOB or empty string
      if (!dob) {
        return;
      }
  
      // Parse DOB in "dd/mm/yyyy" format
      const dobParts = dob.split("/");
      if (dobParts.length !== 3) {
        return;
      }
      const curdate = parseInt(dobParts[0], 10);
      const curmonth = parseInt(dobParts[1], 10) - 1;
  
      if (curdate === today.getDate() && curmonth === today.getMonth()) {
        todayBirthdaysList.push({
          fullName,
          dob,
          contact,
          curdate,
          curmonth,
        });
      } else if (
        curmonth < today.getMonth() ||
        (curmonth === today.getMonth() && curdate < today.getDate())
      ) {
        alreadyBirthdayList.push({
          fullName,
          dob,
          contact,
          curdate,
          curmonth,
        });
      } else {
        upcomingBirthdaysList.push({
          fullName,
          dob,
          contact,
          curdate,
          curmonth,
        });
      }
    });
    // Sort upcoming birthdays by month and day
    upcomingBirthdaysList.sort((a, b) => {
      if (a.curmonth === b.curmonth) {
        return a.curdate - b.curdate;
      }
      return a.curmonth - b.curmonth;
    });
  
    alreadyBirthdayList.sort((a, b) => {
      if (a.curmonth === b.curmonth) {
        return a.curdate - b.curdate;
      }
      return a.curmonth - b.curmonth;
    });
  
    setTodayBirthdays(todayBirthdaysList);
    setUpcomingBirthdays(upcomingBirthdaysList);
    setAlreadyBirthdays(alreadyBirthdayList);
  
  },[userData,horoData]);
  
  
  const token = localStorage.getItem("AdminToken");
  if (!token) {
    return <AdminLogin />;
  }

  function removeDuplicateObjects(arr) {
    const uniqueMap = new Map();

    arr.forEach((obj) => {
      const key = `${obj.fullName}-${obj.dob}-${obj.contact}`;
      uniqueMap.set(key, obj);
    });

    const uniqueArray = Array.from(uniqueMap.values());

    return uniqueArray;
  }

  const uniqueTodayBirthdays = removeDuplicateObjects(todayBirthdays);
  const uniqueUpcomingBirthdays = removeDuplicateObjects(upcomingBirthdays);
  const uniqueAlreadyBirthdays = removeDuplicateObjects(alreadyBirthdays);

  return (
    <>
      <PageHeader title="Birthdays" subtitle="Today and coming up" />
      <SectionTitle>Today ({uniqueTodayBirthdays.length})</SectionTitle>
      <TableContainer borderRadius="lg" border="1px solid" borderColor="stone.200">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Full Name</Th>
              <Th>Date of Birth</Th>
              <Th>Contact</Th>
            </Tr>
          </Thead>
          <Tbody>
            {uniqueTodayBirthdays.map((person, index) => (
              <Tr key={index}>
                <Td>{person.fullName}</Td>
                <Td>{person.dob}</Td>
                <Td>{person.contact}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <SectionTitle>Upcoming ({uniqueUpcomingBirthdays.length+uniqueAlreadyBirthdays.length})</SectionTitle>
      <TableContainer borderRadius="lg" border="1px solid" borderColor="stone.200">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Full Name</Th>
              <Th>Date of Birth</Th>
              <Th>Contact</Th>
            </Tr>
          </Thead>
          <Tbody>
            {uniqueUpcomingBirthdays.map((person, index) => (
              <Tr key={index}>
                <Td>{person.fullName}</Td>
                <Td>{person.dob}</Td>
                <Td>{person.contact}</Td>
              </Tr>
            ))}
            {uniqueAlreadyBirthdays.map((person, index) => (
              <Tr key={index}>
                <Td>{person.fullName}</Td>
                <Td>{person.dob}</Td>
                <Td>{person.contact}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
}

export default Birthday;
